export default "__VITE_ASSET__CFQicwZS__"